<app-form-generator
    [formGeneratorInput]="createTicketFormGenInput"
    (formGroupRef)="createTicketFormGroup = $event"
></app-form-generator>
